import { render, staticRenderFns } from "./LogCidadao.vue?vue&type=template&id=067707f0&"
import script from "./LogCidadao.vue?vue&type=script&lang=js&"
export * from "./LogCidadao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports